import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
// import json from "@/json/items.json";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  created() {
    const userString = localStorage.getItem("user");
    const sellersString = localStorage.getItem("sellers");

    if (userString) {
      const userData = JSON.parse(userString);
      this.$store.commit("SET_USER_DATA", userData);
      if (!sellersString) {
        this.$store.dispatch("getSellersFromServer");
      } else {
        const sellersData = JSON.parse(sellersString);
        this.$store.commit("SET_SELLERS", sellersData);
      }
    } else {
      this.$router.push("/login");
    }
  },
  render: h => h(App)
}).$mount("#app");
